export default __webpack_public_path__ + "static/media/About-Us.269c4d44.jpg";